
import { connect } from 'react-redux';
import ReasonsToBelieve from './ReasonsToBelieve';

const mapStateToProps = ({
  system: { isTouchDevice },
  content: { reasonsToBelieve }
}) => ({
  items: reasonsToBelieve,
  isTouchDevice
});

export default connect(mapStateToProps)(ReasonsToBelieve);